var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Field } from 'react-final-form';
import Payment from 'payment';
import InputAdapter from '../InputAdapter';
import PropTypes from 'prop-types';

export var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocusing: false
    }, _this.formatInput = function (value) {
      var type = _this.props.type;


      if (!value) {
        return value;
      }

      switch (type) {
        case 'cvv':
          {
            var clearValue = value.replace(/\D+/g, '');
            return clearValue.slice(0, 3);
          }

        case 'number':
          {
            var _clearValue = value.replace(/[^\d|\*]/g, ''); // eslint-disable-line
            var nextValue = void 0;
            var issuer = Payment.fns.cardType(value);

            switch (issuer) {
              case 'amex':
                nextValue = _clearValue.slice(0, 4) + ' ' + _clearValue.slice(4, 10) + ' ' + _clearValue.slice(10, 15);
                break;
              case 'dinersclub':
                nextValue = _clearValue.slice(0, 4) + ' ' + _clearValue.slice(4, 8) + ' ' + _clearValue.slice(8, 12) + ' ' + _clearValue.slice(12, 14);
                break;
              default:
                nextValue = _clearValue.slice(0, 4) + ' ' + _clearValue.slice(4, 8) + ' ' + _clearValue.slice(8, 12) + ' ' + _clearValue.slice(12, 16);
                break;
            }

            return nextValue.trim();
          }

        case 'cardHolder':
          {
            var _clearValue2 = value.replace(/\d/g, '');

            return _clearValue2;
          }

        case 'expiration':
          {
            var _clearValue3 = value.replace(/\D+/g, '');
            if (_clearValue3.length >= 3) {
              return _clearValue3.slice(0, 2) + '/' + _clearValue3.slice(2, 4);
            }

            return _clearValue3;
          }
      }
    }, _this.getPattern = function () {
      switch (_this.props.type) {
        case 'cvv':
          {
            return 'd{3,4}';
          }

        case 'number':
          {
            return '[d| ]{16,22}';
          }

        case 'cardHolder':
          {
            return '[^0-9]*';
          }

        case 'expiration':
          {
            return 'd{2}/d{2}';
          }

        default:
          {
            return '[d| ]{16,22}';
          }
      }
    }, _this._handleFocus = function (event) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        isFocusing: true
      });

      onFocus && onFocus(event);
    }, _this._handleBlur = function (event) {
      var onBlur = _this.props.onBlur;


      _this.setState({
        isFocusing: false
      });

      onBlur && onBlur(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          required = _props.required,
          description = _props.description,
          className = _props.className,
          value = _props.value,
          errortext = _props.errortext,
          type = _props.type,
          name = _props.name,
          others = _objectWithoutProperties(_props, ['label', 'required', 'description', 'className', 'value', 'errortext', 'type', 'name']);

      var isFocusing = this.state.isFocusing;

      var hasValue = !!value;

      return React.createElement(
        'div',
        {
          className: 'tg_input ' + (isFocusing ? 'input_focus' : '') + ' ' + (hasValue ? 'tg_input_value' : '') + ' ' + (errortext ? 'error' : '') + ' ' + (className ? className : '') + ' ' + (label ? 'has_title' : '') },
        React.createElement(
          'div',
          {
            className: 'input-wrapper' + (type === 'number' ? ' credit-card-wrapper' : '') },
          React.createElement(
            'label',
            { htmlFor: name },
            label
          ),
          React.createElement(Field, _extends({}, others, {
            name: name,
            component: 'input',
            type: (type === 'number' || type === 'cvv' || type === 'expiration') && 'tel',
            pattern: this.getPattern,
            format: this.formatInput,
            onFocus: this._handleFocus,
            onBlur: this._handleBlur,
            value: value,
            required: required,
            inputMode: (type === 'number' || type === 'cvv') && 'numeric',
            'x-inputmode': (type === 'number' || type === 'cvv') && 'numeric'
          })),
          label && React.createElement(
            'div',
            { className: 'input_title' },
            label + ' ' + (required ? '*' : '')
          )
        ),
        React.createElement('div', { className: 'bottom-line' }),
        errortext && React.createElement(
          'div',
          { className: 'error-message' },
          errortext
        ),
        !errortext && description && React.createElement(
          'div',
          { className: 'input_description' },
          description
        )
      );
    }
  }]);

  return Input;
}(Component);

Input.propTypes = {
  /** Title of the input field */
  label: PropTypes.string,
  /** Type of value */
  type: PropTypes.string.isRequired,
  /** The validation error message */
  errortext: PropTypes.string,
  /** Name associated with each input field */
  name: PropTypes.string,
  /** Boolean props deciding whether a field is required to have a value or not */
  required: PropTypes.bool,
  /** Optional description text */
  description: PropTypes.string,
  /** Placeholder text used on the input */
  placeholder: PropTypes.string,
  /** Classnames that should be used on the input */
  className: PropTypes.string,
  /** The field value */
  value: PropTypes.string,
  /** Function for handling focus on input field  */
  onFocus: PropTypes.func,
  /** Function for when focus is lost from input field */
  onBlur: PropTypes.func
};

export default InputAdapter(Input);